/* c8 ignore file */
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from '@/router/routes'
import { cleanKeycloakCallbackParamsGuard } from '@/router/routerguards'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes
})

export default router

router.beforeEach(cleanKeycloakCallbackParamsGuard)
